import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import * as Roles from '../../common/Roles';

const states: Ng1StateDeclaration[] = [
    {
        name: 'dataFolder',
        url: '/dataFolder',
        component: 'wtDataFolderState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.operator])
        },
        data: {
            isMobileVisible: true,
            icon: 'fa-folder-open',
            displayName: 'Data folder',
            editRoles: [Roles.master, Roles.engineer, Roles.operator],
            editButtonVisibility: () => false
        },
        params: {
            files: null
        }
    }];

export default states;